module.exports = __webpack_public_path__ + "img/tr.7b70fe60.svg";